export var Operation = /*#__PURE__*/ function(Operation) {
    Operation["GreaterThan"] = "greaterThan";
    Operation["GreaterThanEqual"] = "greaterThanEqual";
    Operation["LessThan"] = "lessThan";
    Operation["LessThanEqual"] = "lessThanEqual";
    Operation["IsEmpty"] = "isEmpty";
    Operation["IsNotEmpty"] = "isNotEmpty";
    Operation["Value"] = "value";
    Operation["IsNot"] = "isNot";
    Operation["HasValue"] = "hasValue";
    Operation["Contains"] = "contains";
    Operation["NotContains"] = "notContains";
    Operation["IsNull"] = "isNull";
    Operation["OneOf"] = "oneOf";
    Operation["NoneOf"] = "noneOf";
    return Operation;
}({});
// Plz use this only for trigger condition in automations
export var AutomationOperations = /*#__PURE__*/ function(AutomationOperations) {
    AutomationOperations["IncreasedBy"] = "INCREASED_BY";
    AutomationOperations["DecreasedBy"] = "DECREASED_BY";
    AutomationOperations["ChangedFromTo"] = "CHANGED_FROM_TO";
    AutomationOperations["AddedContainsOneOf"] = "ADDED_CONTAINS_ONE_OF";
    AutomationOperations["RemovedContainsOneOf"] = "REMOVED_CONTAINS_ONE_OF";
    AutomationOperations["BecameEmpty"] = "BECAME_EMPTY";
    AutomationOperations["BecameNotEmpty"] = "BECAME_NOT_EMPTY";
    AutomationOperations["BecameExactly"] = "BECAME_EXACTLY";
    AutomationOperations["BecameNot"] = "BECAME_NOT";
    AutomationOperations["NBecameMoreThan"] = "N_BECAME_MORE_THAN";
    AutomationOperations["NBecameLessThan"] = "N_BECAME_LESS_THAN";
    AutomationOperations["NGreaterThan"] = "N_GREATER_THAN";
    AutomationOperations["NLessThan"] = "N_LESS_THAN";
    AutomationOperations["NIncreasedByMoreThan"] = "N_INCREASED_BY_MORE_THAN";
    AutomationOperations["NDecreasedByMoreThan"] = "N_DECREASED_BY_MORE_THAN";
    AutomationOperations["DIncreasedByMoreThan"] = "D_INCREASED_BY_MORE_THAN";
    AutomationOperations["DDecreasedByMoreThan"] = "D_DECREASED_BY_MORE_THAN";
    AutomationOperations["BecameOneOf"] = "BECAME_ONE_OF";
    AutomationOperations["BecameNoneOf"] = "BECAME_NONE_OF";
    AutomationOperations["DeltaTextContains"] = "DELTA_TEXT_CONTAINS";
    AutomationOperations["DIncreasedByExactly"] = "D_INCREASED_BY_EXACTLY";
    AutomationOperations["DIncreasedByLessThan"] = "D_INCREASED_BY_LESS_THAN";
    AutomationOperations["DDecreasedByExactly"] = "D_DECREASED_BY_EXACTLY";
    AutomationOperations["DDecreasedByLessThan"] = "D_DECREASED_BY_LESS_THAN";
    AutomationOperations["TContains"] = "T_CONTAINS";
    AutomationOperations["TDoesNotContain"] = "T_DOES_NOT_CONTAIN";
    AutomationOperations["IsEmpty"] = "IS_EMPTY";
    AutomationOperations["IsNotEmpty"] = "IS_NOT_EMPTY";
    return AutomationOperations;
}({});
export var NumberOperationType = /*#__PURE__*/ function(NumberOperationType) {
    NumberOperationType["GreaterThan"] = "greaterThan";
    NumberOperationType["LessThan"] = "lessThan";
    NumberOperationType["IsEmpty"] = "isEmpty";
    NumberOperationType["IsNotEmpty"] = "isNotEmpty";
    NumberOperationType["Value"] = "value";
    NumberOperationType["IsNot"] = "isNot";
    return NumberOperationType;
}({});
